import { Routes, Route, BrowserRouter } from 'react-router-dom';
import {
	Home,
	Team,
	Attributions,
	Software,
	Model,
	Collab,
	IHP,
	Entrepreneurship,
	Inclusivity,
	Engineering,
	Experiment,
	Education,
	Safety,
	Parts,
	ProofofConcept,
	Description,
	Contribution,
	Hardware,
	Notebook,
	DrylabModel,
	SDG,
	Awards,
} from './pages';

const Router = () => {
	return (
		<BrowserRouter basename={process.env.PUBLIC_URL}>
			<Routes>
				<Route path='/' element={<Home />} />
				<Route path='/description' element={<Description />} />
				<Route path='/contribution' element={<Contribution />} />
				<Route path='/team' element={<Team />} />
				<Route path='/attributions' element={<Attributions />} />
				<Route path='/software' element={<Software />} />
				<Route path='/model' element={<Model />} />
				<Route path='/mosquito-egg-counter' element={<Collab />} />
				<Route path='/engineering' element={<Engineering />} />
				<Route path='/experiment' element={<Experiment />} />
				<Route path='/safety' element={<Safety />} />
				<Route path='/parts' element={<Parts />} />
				<Route path='/proofofconcept' element={<ProofofConcept />} />
				<Route path='/human-practices' element={<IHP />} />
				<Route
					path='/entrepreneurship'
					element={<Entrepreneurship />}
				/>
				<Route path='/awards' element={<Awards />} />

				<Route path='/inclusivity' element={<Inclusivity />} />
				<Route path='/education' element={<Education />} />
				<Route path='/hardware' element={<Hardware />} />
				<Route path='/notebook' element={<Notebook />} />
				<Route path='/sustainable' element={<SDG />} />
				<Route
					path='/software-drylab-model'
					element={<DrylabModel />}
				/>
			</Routes>
		</BrowserRouter>
	);
};

export default Router;
